import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetPreferredCreditCardsResponse } from '@/types/clientDetailsApiTypes';
import { PREFERRED_CREDIT_CARDS_QUERY_KEY } from '../../consts/client-detail';

export type UseGetPreferredCardsQueryOptions = {
  enabled?: boolean;
};

export const useGetPreferredCardsQuery = (options?: UseGetPreferredCardsQueryOptions) => {
  const [searchQuery] = useSearchQuery();
  const clientId = searchQuery.get(CLIENT_ID_QUERY_KEY);

  const { doFetch } = useFetch<void, GetPreferredCreditCardsResponse>();

  return useQuery({
    queryKey: [PREFERRED_CREDIT_CARDS_QUERY_KEY, clientId],
    queryFn: async () => {
      const data = await doFetch(`/api/preferred-credit-cards/client/${clientId}`);
      return data;
    },
    enabled: options?.enabled !== false && !!clientId,
    staleTime: 30_000,
  });
};
